export default __webpack_public_path__ + "static/media/tc2-logo.0aaccd8e.png";